import React from 'react';
import DeleteIconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';

import { DELETE_EPIC } from '../../apis/epic';
import deleteImg from '../../images/deleteIcon.svg';
import Button from '../atoms/button';
import useProjectVersionHistory from '../../context/VersionHistoryContext';

const propTypes = {
  epicsId: PropTypes.number,
};
const defaultProps = {
  epicsId: 0,
};
const deleteIconButton = (props) => {
  const [open, setOpen] = React.useState(false);
  const [deleteEpic] = useMutation(DELETE_EPIC);
  const { selectedListItem, showVersionHistoryBar, readOnlyMode } = useProjectVersionHistory();
  const deleteButton = async () => {
    setOpen(true);
  };
  const dialogContent = `${props.data.epicId} ${props.data.summary} ?`;
  const handleClickOpen = async () => {
    const variables = {
      input: {
        id: props.data.id,
      },
    };
    await deleteEpic({
      variables,
    });
    setOpen(false);
    const deletedRow = props.node.data;
    props.api.applyTransaction({ remove: [deletedRow] });
    props.api.redrawRows();
    props.colDef.cellEditorParams.stateProps();
  };

  const handleClose = () => {
    setOpen(false);
  };
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  const isHidden =
    showVersionHistoryBar &&
    readOnlyMode &&
    selectedListItem !== null &&
    selectedListItem !== undefined;
  return (
    <span>
      <span>{cellValue}</span>
      <DeleteIconButton
        sx={{ height: 24, width: 24 }}
        style={{
          display: isHidden ? 'none' : '',
          marginLeft: '21.33px',
        }}
        cursor="pointer"
        aria-label="delete"
        onClick={deleteButton}
      >
        <img src={deleteImg} alt="deleteButton" />
      </DeleteIconButton>
      <Dialog
        className="custom-modal-dialog confirmation-modal-dialog"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className="dialog-content">
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete Epic
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            This change will update the timeline
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">{dialogContent}</DialogContentText>
          <DialogContentText id="alert-dialog-description">
            Do you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Button primary outlined onClick={handleClose}>Cancel</Button>
          <Button danger onClick={handleClickOpen} autoFocus>Continue</Button>
        </DialogActions>
      </Dialog>
    </span>
  );
};
deleteIconButton.propTypes = propTypes;
deleteIconButton.defaultProps = defaultProps;
export default deleteIconButton;
